import type { LazyExoticComponent } from 'react';
import { lazy } from 'react';

export interface IRouteDescriptor<TPath extends string> {
	Component: LazyExoticComponent<React.ComponentType>;
	children?: TPath extends string ? IRouteDescriptor<any>[] : never;
	index?: TPath extends string ? never : true;
	path?: TPath extends string ? string : never;
	title?: string;
}

const routes: IRouteDescriptor<string>[] = [
	{
		Component: lazy(() => import('@/pages/SplashScreen/SplashScreen')),
		path: '/splash-screen',
	},
	{
		Component: lazy(() => import('@/pages/Permission/Permission')),
		path: '/permission',
	},
	{
		Component: lazy(() => import('@/pages/Main/Main')),
		path: '/main',
	},
	// {
	// 	path: '/profile',
	// 	component: lazy(() => import('@/pages/Profile/Profile')),
	// },
	{
		Component: lazy(() => import('@/pages/ProfileV2/Profile')),
		children: [
			{
				Component: lazy(() => import('@/pages/ProfileV2/ui/ProfileTab/ProfileTab')),
				index: true,
			},
			{
				Component: lazy(() => import('@/pages/ProfileV2/ui/RewardsTab')),
				children: [
					{
						Component: lazy(() => import('@/pages/ProfileV2/ui/RewardsTab/ui/Rewards/Achievements')),
						path: 'achievements',
					},
					{ Component: lazy(() => import('@/pages/ProfileV2/ui/RewardsTab/ui/RaceWins/RaceWins')), path: 'racewins' },
				],
				path: 'rewards',
			},
			{
				Component: lazy(() => import('@/pages/ProfileV2/ui/TicketsTab/TicketsTab')),
				path: 'tickets',
			},
		],
		path: '/profile',
	},
	{
		Component: lazy(() => import('@/pages/ComboWombo/ComboWombo')),
		path: '/combo',
	},
	{
		Component: lazy(() => import('@/pages/Profile/ui/LegalPage/LegalPage')),
		path: '/profile/legal/:type',
	},
	{
		Component: lazy(() => import('@/pages/TournamentOverview/TournamentOverview')),
		path: '/tournament-overview/:id',
	},
	{
		Component: lazy(() => import('@/pages/TournamentSelection/TournamentSelection')),
		path: '/tournament-selection',
	},
	{
		Component: lazy(() => import('@/pages/Leaderboard/Leaderboard')),
		path: '/leaderboard/:step/:id',
	},
	{
		Component: lazy(() => import('@/pages/Payment/Payment')),
		path: '/payment/:type/:tournamentId/:paymentId',
	},
	{
		Component: lazy(() => import('@/pages/DailyBonuses/DailyBonuses')),
		path: '/daily-bonuses',
	},
	{
		Component: lazy(() => import('@/pages/NotFound/NotFound')),
		path: '',
	},
];

export default routes;
